import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { AdministrationService } from 'src/app/services/administration/administration.service';
import * as moment from 'moment'


@Component({
  selector: 'app-academic',
  templateUrl: './academic.component.html',
  styleUrls: ['./academic.component.css']
})
export class AcademicComponent implements OnInit {
  ClassList: any;
  Submitted: boolean = false;
  AcademicList: any;
  SelectedFileForUpload: any;
  @ViewChild('fileUploader', { static: false }) fileUploader: ElementRef;
  constructor(private adminservice: AdministrationService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }


   SearchModel={
    AcademicTypeID:0,
    ClassID:0,
    SectionID:0
   } 

   ClearSearch(){
    this.SearchModel.ClassID=0;
    this.SearchModel.AcademicTypeID=0;
    this.AcademicList=[];
   }
   GetAllAcademic() {
    this.spinnerService.show();
    this.adminservice.GetAllAcademic(JSON.stringify(this.SearchModel)).subscribe((response: any) => {
      this.AcademicList = response.AcademicList;
      this.spinnerService.hide();
      this.globalHelper.CheckActionStatus(response);
    });
  };

  AcademicModel = {
    AcademicID: 0,
    Title: '',
    AcademicTypeID: 0,
    IsActive: true,
    FilePath:'',
    ClassID: 0,
    SectionID:0,
    Type:''
  };

  Clear() {

    this.AcademicModel.AcademicID = 0;
    this.AcademicModel.AcademicTypeID=0;
    this.AcademicModel.Title = '';
    this.AcademicModel.FilePath = '';
    this.AcademicModel.ClassID = 0;
    this.AcademicModel.SectionID = 0;
    this.Submitted = false;
    this.fileUploader.nativeElement.value = null;
    this.SelectedFileForUpload=null;
  };


 
  selectFileforUpload(file) {
    this.SelectedFileForUpload = file[0];
  };

  ValidState(){
    return this.AcademicModel.ClassID==0||this.AcademicModel.AcademicTypeID==0||(this.AcademicModel.AcademicTypeID==1 && this.AcademicModel.SectionID==0);
  }

  SaveAcademic(valid) {
    this.Submitted = true;
     if (valid && !this.ValidState()) {
      this.spinnerService.show();
      this.adminservice.SaveAcademic(JSON.stringify(this.AcademicModel), this.SelectedFileForUpload).subscribe((data: any) => {
        if (data.webResponse.Status && this.AcademicModel.AcademicID == 0) {
          this.Clear();
        }
        this.GetAllAcademic();
        this.spinnerService.hide();
        this.globalHelper.CheckActionStatus(data);

      });
    }
  }

  Edit(obj) {

    this.AcademicModel.ClassID = obj.ClassID;
    this.GetSection(this.AcademicModel.ClassID);
    this.AcademicModel.SectionID = obj.SectionID;
    this.AcademicModel.AcademicID = obj.AcademicID;
    this.AcademicModel.Title = obj.Title;
    this.AcademicModel.FilePath = obj.FilePath;
    this.AcademicModel.IsActive = obj.IsActive;
    this.AcademicModel.AcademicTypeID = obj.AcademicTypeID;

  };


  AcademicMarkActive(obj) {
    this.Clear();
    this.AcademicModel.AcademicID = obj.AcademicID;
    this.AcademicModel.IsActive = obj.IsActive == true ? false : true;
    this.spinnerService.show();
    this.adminservice.AcademicMarkActive(this.AcademicModel.AcademicID,this.AcademicModel.IsActive).subscribe((response: any) => {
      this.spinnerService.hide();
      this.GetAllAcademic();
      this.globalHelper.CheckActionStatus(response);

    });
  }


  ngOnInit() {

   this.BindClass();
   this.BindAcademicType();



  }

  SectionList=[];
  GetSection(ClassID) {
    
    var ItemBo = {
        'ItemId': ClassID
    }
    this.lookupservice.GetLookupsList('SectionName', JSON.stringify(ItemBo)).subscribe((data) => {
        this.SectionList = data.LookupItems;
     
    });
};
 
 
  BindClass() {
    this.lookupservice.GetLookupsList('Class', '').subscribe((data: any) => {
      this.ClassList = data.LookupItems;
     
    });
  };
  AcademicTypeList=[];
  BindAcademicType() {
    this.lookupservice.GetLookupsList('AcademicType', '').subscribe((data: any) => {
      this.AcademicTypeList = data.LookupItems;
     
    });
  };


}




